import { connect } from 'react-redux';
import JamMengajar from '../../views/Settings/JamMengajar.view';
import {
  getUserGroups, getSchoolUnitsOptions, getParamPerwakilan,
  getPrmStaffKepsek, getParamOptionsAcademics
} from '../../states/thunks/options.thunk';
import { listBlockUnits, editTeachSchedule, saveTeachSchedule, listTeachSchedule, deleteTeachSchedule } from '../../states/thunks/academics.thunk';

function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    levels: state.options.levels,
    user: state.user || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleListBlockUnits: (payload, goback) => dispatch(listBlockUnits(payload, goback)),
    getPrmStaffKepsekOptions: payload => dispatch(getPrmStaffKepsek(payload)),
    getUserGroups: payload => dispatch(getUserGroups(payload)),
    getSchoolUnitsOptions: payload => dispatch(getSchoolUnitsOptions(payload)),
    getParamPerwakilan: payload => dispatch(getParamPerwakilan(payload)),
    handleListTeachSchedule: (payload, goback) => dispatch(listTeachSchedule(payload, goback)),
    handleSaveTeachSchedule: (payload, goback) => dispatch(saveTeachSchedule(payload, goback)),
    handleEditTeachSchedule: (payload, goback) => dispatch(editTeachSchedule(payload, goback)),
    handleDeleteTeachSchedule: (payload, goback) => dispatch(deleteTeachSchedule(payload, goback)),
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(JamMengajar);
